import React from 'react';
import { useState } from 'react';
import { Modal, Button, Container, Grid, Checkbox, Group, Text } from '@mantine/core';
import { InfoCircle } from 'tabler-icons-react';

import './ToggleModal.css';
import { CheckIcon } from '@radix-ui/react-icons';

function ArtworkModal({ opened, setOpened, confirm }) {
  const [disabled, setDisabled] = useState(true);

  const handleChange = (event) => {
    event.target.checked ? setDisabled(false) : setDisabled(true);
  };

  const handleConfirm = () => {
    confirm({ target: { name: 'artwork_change', value: true } });
    setOpened(false);
  };

  return (
    <Modal
      opened={opened}
      onClose={() => setOpened(false)}
      title='Disclaimer'
      className='toggle-modal'
    >
      <Container>
        <Grid>
          <Grid.Col span={12}>
            <Group noWrap className='disclaimer-modal-group'>
              <InfoCircle color='black' size='5rem' />
              <Text size='sm'>
                The Initiator confirms that Art Work changes have been approved by Brand / Marketing
                team - Responsibility on Obsoletes or Business impacts resulting by lack of
                compliance on this point wll be responsibility of Initiator
              </Text>
            </Group>
          </Grid.Col>
          <Grid.Col span={12}>
            <Checkbox
              onChange={handleChange}
              className='modal-checkbox'
              label='I accept the terms and conditions above.'
            ></Checkbox>
          </Grid.Col>
          <Grid.Col span={3} offset={9}>
            <Button disabled={disabled} variant='gradient' onClick={handleConfirm} fullWidth>
              OK
            </Button>
          </Grid.Col>
        </Grid>
      </Container>
    </Modal>
  );
}

export default ArtworkModal;
